// extracted by mini-css-extract-plugin
export default {"disclaimer":"styles_disclaimer__2kZrQ","topMargin":"styles_topMargin__8SfEV","darkTheme":"styles_darkTheme__MrTEE"};